import { selector } from 'recoil';
import { GetFilterStatusesRequest } from '../../api';
import { ConsultationViewTypes } from '../../types';
import { searchViewTypeState } from './searchViewTypeState';

export const filterArchiveRequestState = selector<GetFilterStatusesRequest>({
  key: 'filterArchiveRequest',
  get: ({ get }) => ({
    archive: get(searchViewTypeState) === ConsultationViewTypes.Archived,
  }),
});
